import { useState } from "react";
import { useDispatch } from "react-redux";
import { setCurrentMail } from "../../../Slices/notification";
import { Card, Typography } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faLock, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { AntdButton, InputField } from "../../../blueplanitUtils/InputField";
import { validateOutlook } from "../../../Slices/Thunk/notification";

const { Title } = Typography;

const OutlookLoginPage = ({ onLoginSuccess }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [formValues, setFormValues] = useState({ email: "", password: "" });
    const dispatch = useDispatch();

    const handleChange = (e) => {
        setFormValues({ ...formValues, [e.target.name]: e.target.value });
    };

    const handleLogin = async () => {
        if (!formValues.email || !formValues.password) {
            setError("Please fill in both fields");
            return;
        }

        setLoading(true);
        setError("");

        try {
            // 🔹 Replace fetch with thunk
            const data = await dispatch(
                validateOutlook({
                    email: formValues.email,
                    password: formValues.password,
                })
            ).unwrap();

            if (data.valid) {
                localStorage.setItem("outlookToken", "true");
                dispatch(setCurrentMail(formValues.email));
                onLoginSuccess();
            } else {
                setError("Invalid credentials");
            }
        } catch (err) {
            console.error(err);
            setError("Login failed");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            className="page-wrapper"
            style={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <div style={{ maxWidth: 500, width: "100%", padding: "20px" }}>
                <Card
                    style={{
                        borderRadius: "16px",
                        boxShadow: "0 8px 24px rgba(0, 0, 0, 0.15)", // softer shadow
                        overflow: "hidden",
                    }}
                >
                    <div className="text-center mb-6">
                        <img
                            src="./outlook.png"
                            alt="Outlook Logo"
                            className="h-12 mx-auto"
                        />
                        <Title level={3} style={{ marginTop: 12 }}>
                            Outlook Login
                        </Title>
                    </div>

                    {/* Email Input */}
                    <div className="mb-4">
                        <InputField
                            name="email"
                            value={formValues.email}
                            onChange={handleChange}
                            size="large"
                            placeholder="Outlook Email"
                            prefix={<FontAwesomeIcon icon={faEnvelope} className="text-gray-400" />}
                        />
                    </div>

                    {/* Password Input */}
                    <div className="mb-4 relative">
                        <InputField
                            name="password"
                            value={formValues.password}
                            onChange={handleChange}
                            type={showPassword ? "text" : "password"}
                            size="large"
                            placeholder="Outlook Password"
                            prefix={<FontAwesomeIcon icon={faLock} className="text-gray-400" />}
                            suffix={
                                <FontAwesomeIcon
                                    icon={showPassword ? faEyeSlash : faEye}
                                    className="cursor-pointer text-gray-500"
                                    onClick={() => setShowPassword(!showPassword)}
                                />
                            }
                        />
                    </div>

                    {/* Error Message */}
                    {error && <p style={{ color: "red", textAlign: "center", marginBottom: "12px" }}>
                        {error}
                    </p>
                    }

                    {/* Buttons */}
                    <AntdButton
                        type="primary"
                        block
                        size="large"
                        loading={loading}
                        onClick={handleLogin}
                        label={"Login"}
                    />
                </Card>
            </div>
        </div>
    );
};

export default OutlookLoginPage;
